import React from 'react';
import SettingsContainer, { SettingsSettingType } from '../../../components/settings/SettingsContainer';

const OrderSettings: React.FC = () => {
    const settings: SettingsSettingType[] = [
        {
            title: 'order.settings.numbering_scheme_title',
            explanationText: 'order.settings.numbering_scheme_explanation',
            fields: [
                {
                    type: 'text',
                    label: 'settings.general.number_sequence_title',
                    name: 'order_numbering_scheme',
                    placeholder: '',
                    group: 'field-row',
                    width: '30%',
                    shouldAutoFocus: false
                },
                {
                    type: 'number',
                    label: 'settings.general.next_number_label',
                    name: 'order_current_number',
                    width: '30%',
                    group: 'field-row'
                }
            ]
        },
        // TODO: commented out, has to be implemented again
        // {
        //     title: 'Gewonnen offertes omzetten in orders',
        //     explanationText: 'Laat automatisch een order aanmaken zodra een offerte is geaccepteerd.',
        //     switchButton: {
        //         enabled: true,
        //         name: '',
        //     }
        // },
    ];

    return (
        <SettingsContainer settings={settings} environmentScope={true} />
    );
};

export default OrderSettings;